import React from "react";
import "./BotAppearence.css"

const BotAppearence = () => {
  return (
    <div className="docs-appearance-container">
      <h1 className="docs-appearance-title">Customizing Chatbot Appearance</h1>

      <p className="docs-appearance-intro">
        The <strong>Appearance</strong> settings allow you to fully tailor the look and feel 
        of your chatbot to match your brand identity and user experience goals. 
        Access these settings from your dashboard:
      </p>

      <ol className="docs-appearance-steps">
        <li>Navigate to <strong>Your Bots</strong> on the dashboard.</li>
        <li>Select the bot you want to customize.</li>
        <li>Open <strong>Settings</strong> from the left sidebar and click on <strong>Appearance</strong>.</li>
      </ol>

      <h2 className="docs-appearance-section-title">Key Appearance Options</h2>

      <div className="docs-appearance-option">
        <h3 className="docs-appearance-option-title">Bot Name on the Widget</h3>
        <p>This is the name displayed on the chatbot widget itself, helping users immediately recognize the bot.</p>
      </div>

      <div className="docs-appearance-option">
        <h3 className="docs-appearance-option-title">Bot Name in Chat</h3>
        <p>This name appears within the chat interface when the bot sends messages. Customize it to maintain consistent branding or a conversational tone.</p>
      </div>

      <div className="docs-appearance-option">
        <h3 className="docs-appearance-option-title">Subheading (Optional)</h3>
        <p>A brief subheading under the bot name in the chat interface. Useful for providing context or guiding users.</p>
      </div>

      <div className="docs-appearance-option">
        <h3 className="docs-appearance-option-title">XenaChat Branding on Widget</h3>
        <p>
          By default, <strong>XenaChat branding</strong> is applied. You can enable the <strong>Hide Branding</strong> option from the Manage Plans section.
        </p>
      </div>

      <div className="docs-appearance-option">
        <h3 className="docs-appearance-option-title">Bot Avatar</h3>
        <p>Customize the bot avatar to reflect your brand. The current avatar is displayed for reference, with the option to update it.</p>
      </div>

      <div className="docs-appearance-option">
        <h3 className="docs-appearance-option-title">Accent Color</h3>
        <p>Choose an accent color for the widget to match your brand palette. It affects chat bubbles, buttons, and highlights.</p>
      </div>

      <div className="docs-appearance-option">
        <h3 className="docs-appearance-option-title">Widget Icon & Position</h3>
        <ul>
          <li><strong>Widget Icon:</strong> Customize the icon appearing on the bottom corner of your website.</li>
          <li><strong>Widget Position:</strong> Place the widget on the <em>left</em> or <em>right</em> side of the screen. (Does not apply to preview.)</li>
        </ul>
      </div>

      <div className="docs-appearance-option">
        <h3 className="docs-appearance-option-title">Input Placeholder</h3>
        <p>Set placeholder text in the chat input box to guide users on what they can ask or type.</p>
      </div>

      <div className="docs-appearance-option">
        <h3 className="docs-appearance-option-title">Widget Default State</h3>
        <p>Decide whether the chat widget is open or closed when a user first engages with your website.</p>
      </div>

      <div className="docs-appearance-option">
        <h3 className="docs-appearance-option-title">Starter Questions</h3>
        <p>Enable floating starter questions to help users quickly engage with your bot. These are predefined prompts for easy interaction.</p>
      </div>

      <div className="docs-appearance-footer">
        <p>After customizing your bot appearance:</p>
        <ul>
          <li><strong>Save Changes</strong> to apply updates.</li>
          <li><strong>Discard Changes</strong> to revert any unsaved modifications.</li>
        </ul>
      </div>
    </div>
  );
};

export default BotAppearence;
